var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BjDialog",
        {
          attrs: {
            title: _vm.$t("BusinessStockDeliveryCom.title"),
            visible: _vm.visible,
            width: "500px",
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.comfirm } },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.data, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "60",
                  label: _vm.$t("table.countText"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "code",
                  label: _vm.$t("BusinessStockDeliveryCom.code"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "link" }, [
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.onView(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.code))]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }